/**
 * Reverose — Boutons de taille des cartes produit (snippets/rv-card-sizes.liquid).
 *
 * Au clic sur une taille : ouvre la fenêtre d'ajout rapide native de la carte
 * (quick-add-component#handleClick), puis y coche la taille choisie.
 * Sans ajout rapide dans la page (réglages désactivés, fiche épuisée), mène à la fiche
 * avec la taille sélectionnée (?variant=).
 */
class RvCardSizes extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  /** @param {MouseEvent} event */
  #handleClick = async (event) => {
    // La carte navigue vers la fiche sur tout clic qui n'est pas un lien ou un bouton :
    // un clic entre deux tailles ou sur une taille désactivée ne doit pas quitter la page.
    event.stopPropagation();

    const button = event.target instanceof Element ? event.target.closest('button[data-variant-id]') : null;
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    event.preventDefault();

    const variantId = button.dataset.variantId ?? '';
    const variantUrl = button.dataset.variantUrl ?? '';
    const quickAdd = /** @type {(HTMLElement & { handleClick?: (event: Event) => Promise<void> }) | null | undefined} */ (
      this.closest('product-card')?.querySelector('quick-add-component')
    );

    if (!quickAdd || typeof quickAdd.handleClick !== 'function' || !document.getElementById('quick-add-dialog')) {
      if (variantUrl) window.location.href = variantUrl;
      return;
    }

    button.setAttribute('aria-busy', 'true');
    try {
      await quickAdd.handleClick(event);
      this.#selectVariant(variantId);
    } catch (error) {
      console.warn('[rv-card-sizes] Ajout rapide indisponible, ouverture de la fiche', error);
      if (variantUrl) window.location.href = variantUrl;
    } finally {
      button.removeAttribute('aria-busy');
    }
  };

  /**
   * Coche la variante dans la fenêtre d'ajout rapide (boutons ou menu déroulant).
   * Le sélecteur natif réagit à l'événement « change » (prix, bouton, disponibilité).
   * @param {string} variantId
   */
  #selectVariant(variantId) {
    const content = document.getElementById('quick-add-modal-content');
    if (!content || !variantId) return;

    const selector = `[data-variant-id="${CSS.escape(variantId)}"]`;

    const input = content.querySelector(`input[type="radio"]${selector}`);
    if (input instanceof HTMLInputElement) {
      if (!input.checked && !input.disabled) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    const option = content.querySelector(`option${selector}`);
    const select = option?.closest('select');
    if (option instanceof HTMLOptionElement && select instanceof HTMLSelectElement && !option.disabled) {
      if (select.value !== option.value) {
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }
}

if (!customElements.get('rv-card-sizes')) {
  customElements.define('rv-card-sizes', RvCardSizes);
}
